export const RouteConstants = {
  Home: 'home',
  Login: 'login',
  Studio: 'studio',
  // STUDIO env
  OcrPlayground: 'ocr-playground',
  CategoryList: 'category-list',
  // ESIGN env
  Dashboard: 'dashboard',
  ESign: 'esign',
  History: 'history',
  Wallet: 'wallet',
};
